import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {

  maintenanceLanguage: string;
  isMaintenance: boolean = false;
  maintenanceMode$ = new BehaviorSubject(false);

  setMaintenanceMode(lang?: string): void {
    this.maintenanceMode$.next(true);
    this.isMaintenance = true;
    this.maintenanceLanguage = lang;
  }

}
